import { config, getSDK, resolveMeetingAssistEnabled } from '@littlebird/sdk';

import { trackEvent } from '@/utils/analytics';

import type { MeetingAssistSurface } from './use-meeting-assist';

type MeetingAssistSettingSurface = MeetingAssistSurface | 'settings';

export function setMeetingAssistEnabled(
  enabled: boolean,
  surface: MeetingAssistSettingSurface
): void {
  trackEvent('MEETING_ASSIST_SETTING_CHANGED', {
    previous_value: resolveMeetingAssistEnabled(
      config.meetings.meeting_assist_enabled
    ),
    new_value: enabled,
    surface,
  });
  getSDK().userConfig.meetings.set('meeting_assist_enabled', enabled);
}
